import axios, { AxiosPromise } from 'axios';
import config from '@/config';
import { User } from '@/modules/authentication/models/user';

const resourceEndpoint = `${config.api.url}${config.api.privateEndpointsPrefix}${config.api.endpoints.users}`;

export function fetchAll(): AxiosPromise<User[]> {
  return axios.get(`${resourceEndpoint}/all`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function me(): AxiosPromise<User> {
  return axios.get(`${resourceEndpoint}/me`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function update(user: User): AxiosPromise<User> {
  const body = {
    user
  };
  return axios.put(`${resourceEndpoint}/${user.id}`, body, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}
